export const FootnoteMessage = "Please select a filter or enter a search parameter to generate this report.";
